import { render, staticRenderFns } from "./channelChart.vue?vue&type=template&id=32685da0&scoped=true"
import script from "./channelChart.vue?vue&type=script&lang=js"
export * from "./channelChart.vue?vue&type=script&lang=js"
import style0 from "./channelChart.vue?vue&type=style&index=0&id=32685da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32685da0",
  null
  
)

export default component.exports